import type { ReactElement } from 'react';
import type { EViewMode } from 'reactApp/modules/settings/settings.types';

export interface IProps {
    list: VirtualListItem[];
    itemWidth?: number;
    rowHeight: number;
    viewMode?: EViewMode;
    dividerHeight?: number;
    dividerSize?: EDividerSize;
    itemHeight?: number;
    hasMoreToLoad: boolean;
    loadOnScroll: () => void;
    loadOnAnchor?: (anchorId: string, direction: 'up' | 'down') => void;
    onItemsRendered?: ({ start, stop }: { start: number; stop: number }) => void;
    isLoading: boolean | undefined;
    customScrollElement?: HTMLDivElement | null;
    renderItem: (
        id: string,
        options: { index: number },
        extraItemProps: { onItemSizeChange?: (size: number) => void }
    ) => ReactElement | null;
    className?: string;
    disableScroll?: boolean;
    lowOverscan?: boolean;
    setScrollTopBtnClicked?: (value: boolean) => void;
    scrollTopBtnClicked?: boolean;
    setIsScrolledToTop?: (value: boolean) => void;
}

export type IVirtualListLoaderProps = Pick<IProps, 'isLoading' | 'loadOnScroll' | 'className'>;

export interface IVirtualList {
    // Индекс элемента, к которому надо скроллить
    scrollToItem: (index: number, aligmentOption?: EAligment) => void;
    // Возвращает количество колонок
    getColumnsCount: () => number;
}

export enum EAligment {
    START = 'start',
    CENTER = 'center',
    SMART = 'smart',
}

export enum EDividerSize {
    SMALL = 'small',
}

export interface VirtualListDivider {
    divider: true;
    text?: string;
    showAdv?: boolean;
    forGallery?: boolean;
    id?: string;
    showRemoveDuplicatesBtn?: boolean;
    duplicatesGroupId?: string;
}

export interface VirtualIndex {
    start: number;
    end: number;
    id?: string;
}

export type VirtualListItem = string | VirtualListDivider;
